'use strict';
import * as PerfectScrollbar from 'perfect-scrollbar';

export const scrollPaneModule = angular
  .module('wmpcp.widgets.scroll-pane', [])
  .directive('wmpcpScrollPane', [
    '$window',
    '$timeout',
    function($window, $timeout) {
      const psOptions = [
        'wheelSpeed',
        'wheelPropagation',
        'minScrollbarLength',
        'useBothWheelAxes',
        'useKeyboard',
        'suppressScrollX',
        'suppressScrollY',
        'scrollXMarginOffset',
        'scrollYMarginOffset',
        'includePadding',
      ];

      return {
        link: function link(scope, element, attrs) {
          let prefixedOpt = void 0;
          const nativeElement = element[0];
          const options = {
            scrollXMarginOffset: 10,
            scrollYMarginOffset: 10,
          };

          if (element.data('hasScrollPane')) {
            // make only one scroll pane for element. (for ui-selector)
            return;
          }
          element.data('hasScrollPane', true);

          psOptions.forEach(function(opt) {
            prefixedOpt = 'sp' + opt[0].toUpperCase() + opt.slice(1);
            if (prefixedOpt in attrs) {
              if (
                prefixedOpt === 'spScrollXMarginOffset' ||
                prefixedOpt === 'spScrollYMarginOffset'
              ) {
                options[opt] = parseInt(attrs[prefixedOpt], 10);
              } else {
                options[opt] = attrs[prefixedOpt];
              }
            }
          });

          // scope.$on('$stateChangeSuccess', function(
          //   event,
          //   toState,
          //   toParams,
          //   fromState,
          // ) {
          //   if (!(toState.isModal || fromState.isModal)) {
          //     element.scrollTop(0);
          //     element.scrollLeft(0);
          //   }
          // });

          function updateScrollPane() {
            // wait for other processes to be completed
            $timeout(
              function() {
                PerfectScrollbar.update(nativeElement);
              },
              0,
              false,
            );
          }

          function watchHandler(newValue, oldValue) {
            if (newValue === oldValue) {
              PerfectScrollbar.initialize(nativeElement, options);
            } else {
              updateScrollPane();
            }
          }

          if (attrs.spWatch) {
            scope.$watch(attrs.spWatch, watchHandler);
          } else if (attrs.spWatchCollection) {
            scope.$watchCollection(attrs.spWatchCollection, watchHandler);
          } else if (attrs.hasOwnProperty('spPostDigest')) {
            (function() {
              let timer = void 0;
              let lastHeight = void 0;
              watchHandler(0, 0);
              scope.$watch(function() {
                if (!timer) {
                  timer = $timeout(
                    function() {
                      const newHeight = nativeElement.scrollHeight;

                      if (lastHeight !== newHeight) {
                        watchHandler(newHeight, lastHeight);
                      }
                      lastHeight = newHeight;
                      timer = null;
                    },
                    0,
                    false,
                  );
                }
                return lastHeight;
              });
            })();
          } else {
            scope.$watch(function watchExp() {
              return nativeElement.scrollHeight;
            }, watchHandler);
          }

          $window.addEventListener('resize', updateScrollPane);

          scope.$on('$destroy', function() {
            element.data('hasScrollPane', false);
            $window.removeEventListener('resize', updateScrollPane);
            PerfectScrollbar.destroy(nativeElement);
          });
        },
      };
    },
  ]);
